import { formatISODateTime } from "@clipboard-health/date-time";
import { TimePicker } from "@mui/x-date-pickers";
// eslint-disable-next-line no-restricted-imports -- @clipboard-health/date-time does not provide HH:mm parsing for picker values
import { isValid, parse } from "date-fns";

import { PickerTextInput } from "./PickerTextInput";

interface InterviewTimePickerFieldProps {
  value?: string;
  onChange: (value: string | undefined) => void;
  error?: boolean;
  label?: string;
  ariaLabel?: string;
  disabled?: boolean;
}

export function InterviewTimePickerField(props: InterviewTimePickerFieldProps) {
  const { value, onChange, error, label, ariaLabel, disabled } = props;
  const parsedTimeValue = value ? parse(value, "HH:mm", new Date()) : undefined;
  const timeValue = parsedTimeValue && isValid(parsedTimeValue) ? parsedTimeValue : null;

  return (
    <TimePicker
      skipDisabled
      ampm
      label={label}
      value={timeValue}
      disabled={disabled}
      slots={{ textField: PickerTextInput }}
      slotProps={{
        textField: {
          size: "small",
          inputProps: {
            "aria-label": ariaLabel,
          },
          sx: {
            width: { xs: "100%", sm: "9rem" },
            minWidth: 0,
          },
          error,
        },
      }}
      minutesStep={15}
      onChange={(newValue) => {
        if (newValue && isValid(newValue)) {
          onChange(formatISODateTime(newValue).slice(11, 16));
          return;
        }

        onChange(undefined);
      }}
    />
  );
}
